<ng-container *ngIf="usedDashboards.length">
  <div class="used-dashboards-container">
    <div class="d-flex align-items-center justify-content-start">
      <morva-icons icon="warning"></morva-icons>
      منبع داده مورد نظر در داشبورد‌های زیر استفاده می‌شود.
    </div>
    <mat-accordion class="example-headers-align">
      <mat-expansion-panel #panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            لیست داشبوردها
            ({{usedDashboards.length}})
          </mat-panel-title>
          <span class="panel-toggle-text">{{panel.expanded ? 'کمتر' : 'بیشتر'}}</span>
        </mat-expansion-panel-header>
        <mat-list role="list" class="custom-scroll">
          <mat-list-item role="listitem" *ngFor="let dashboard of usedDashboards;">
            <span style="display: flex !important;align-items: center !important;">
              <morva-icons icon="dashboard"></morva-icons>
            <span style="font-size: 11px;">{{dashboard}}</span>
            </span>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</ng-container>
